import api from "api";
import * as constants from "./actionTypes";
import { processFormData, showToast } from "../utils/helpers";
import { setCurrentUser } from "newui/features/Auth/authSlice";
import { apiV1 } from "api-v2";

// TODO: need to migrate all use-cases to api-v1 or api-v2
function getApiWithToken() {
	return api;
}

export const getCompanyUsers = (company_id) => async (dispatch) => {
	(async () => {
		const company_users = await apiV1.get(`all-users/${company_id}`);
		await dispatch({
			type: constants.GET_COMPANY_USERS,
			payload: company_users?.data,
		});
	})();
};

export const update_user = (values, profile = false) => {
	values.position === "administrator"
		? (values["company_admin"] = 1)
		: (values["company_admin"] = 0);
	if (!values.password) {
		delete values["password"];
	}
	return async (dispatch) => {
		const formData = processFormData(values);
		try {
			const result = await apiV1
				.patch(`users/${values.id}`, formData);
			const user = result.data?.data;
			if (profile && user) {
				localStorage.removeItem('redirect_path');
				await dispatch(setCurrentUser(user));
				return user;
			} else {
				return user;
			}
		} catch (e) {
			// apiv1 handles error messaging
			return false;
		}
	};
};

export const changePasswordActions = (values, userId) => {
	return async (dispatch) => {
		const formData = processFormData(values);
		try {
			const response = await api
				.patch(`users/${userId}/password`, {
					body: formData,
				})
				.json();
			const result = response.status;
			if (result) {
				showToast("Password changed", "Success", true);
				return true;
			} else {
				showToast("Failed to change password", "Failed", false);
				return false;
			}
		} catch (e) {
			const error = await e.response.json();
			let msg = error.message;

			if (error.errors?.password) {
				msg = error.errors?.password.join('. ');
			}

			showToast(msg || "Failed to change password", "Error");
			return false;
		}
	};
};

export const allTransaction = (company_id) => {
	return async (dispatch) => {
		(async () => {
			try {
				const all_transactions = await getApiWithToken()
					.get(`all-transaction/${company_id}`)
					.json();

				await dispatch({
					type: constants.TRANSACTION_DETAILS,
					payload: all_transactions.data,
				});
			} catch (e) {
				console.log(e.response);
			}
		})();
	};
};

export const delete_user = (id) => {
	return async () => {
		try {
			const user = await api.delete(`users/${id}`).json();
			if (user.status === "success") {
				return user;
			} else {
				return user;
			}
		} catch (e) {
			// const error = await e.response;
			// cheat fix
			showToast("User deleted", "Success", true);
			// showToast(error.error, "Error");
		}
	};
};

export const delete_plan = (id) => {
	return async (dispatch) => {
		const formData = processFormData({
			account_type_id: null,
		});

		const company = await getApiWithToken()
			.patch(`companies/${id}`, { body: formData })
			.json();
		await dispatch({
			type: constants.SUBMIT_COMPANY_PROFILE_FORM,
			payload: company.data,
		});
		showToast("Plan Updated", "Success", true);
		return company;
	};
};

export const create_draft = (values) => {
	return async (dispatch) => {
		const formData = processFormData(values);
		try {
			const user = await getApiWithToken()
				.post("user-draft/create", {
					body: formData,
				})
				.json();
			if (user.success) {
				showToast("Details Saved", "Success", true);
			}
		} catch (e) {
			const error = await e.response.json();
			showToast(error.error, "Error");
		}
	};
};

export const cancel_subs = async (mes) => {
	const formData = new FormData();
	formData.append("cancellation_reason", mes);
	try {
		const canceled = await getApiWithToken()
			.post("subscription/cancel", {
				body: formData,
				timeout: 60000,
			})
			.json();
		showToast(
			"Subscription cancelled. All Admin Users will be notified via email of this cancellation",
			"Success",
			true
		);
		return canceled;
	} catch (e) {
		showToast("Cancelling Subscription Failed", "Error");
		throw e;
	}
};

export const restart_subs = () => {
	return async (dispatch) => {
		try {
			const restarted = await getApiWithToken()
				.patch("subscription/restart", {})
				.json();
			await dispatch({
				type: constants.SET_ACCOUNT_STATUS,
				payload: null,
			});
			showToast("Subscription Restarted", "Success", true);
			return restarted;
		} catch (e) {
			showToast("Restarting Subscription Failed", "Error");
			throw e;
		}
	};
};

export const setAccountStatus = (status) => {
	return async (dispatch) => {
		await dispatch({
			type: constants.SET_ACCOUNT_STATUS,
			payload: status,
		});
	};
};
